export const template5PlaceholderData = {
  id: 1,
  name: 'Menu 1',
  categories: [
    {
      id: 1,
      name: 'Pizza',
      items: [
        {
          id: 1,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 2,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 3,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 4,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 5,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 6,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
          outOfStock: true,
        },
        {
          id: 7,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 8,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
    {
      id: 2,
      name: 'Burger',
      items: [
        {
          id: 9,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 10,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 11,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 12,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 13,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 14,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '15',
          modifiers: {},
        },
      ],
    },
    {
      id: 3,
      name: 'Drinks',
      items: [
        {
          id: 15,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 16,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 17,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 18,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 19,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 20,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          outOfStock: true,
        },
        {
          id: 21,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 22,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 23,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 24,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 25,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 26,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 27,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 28,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 29,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 30,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 31,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 32,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 33,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 34,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 35,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 36,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 37,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 38,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 39,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 40,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 41,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 42,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 43,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 44,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 45,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 46,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 47,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 48,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 49,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 50,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
        {
          id: 51,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
      ],
    },
  ],
};
